let configuredApiUrl: string | null = null;

export const setApiUrl = (url: string): void => {
  configuredApiUrl = url;
};

export const getApiUrl = (): string | null => {
  return configuredApiUrl;
};
